/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Shape } from "./Shape";
import { markType } from "./type";
/**
 * @hidden
 */
var Line = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Line, _super);
    function Line() {
        var _this = _super.call(this) || this;
        _this.ak = 0;
        _this.al = 0;
        _this.am = 0;
        _this.an = 0;
        _this.ak = 0;
        _this.al = 0;
        _this.am = 0;
        _this.an = 0;
        return _this;
    }
    Line.$t = markType(Line, 'Line', Shape.$);
    return Line;
}(Shape));
export { Line };
//# sourceMappingURL=Line.js.map
